import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  // =========================================================
  // ARABIC
  // =========================================================
  ar: {
    translation: {
      // =====================================================
      // NAVIGATION
      // =====================================================
      nav: {
        home: "الرئيسية",
        about: "عن المركز",
        services: "خدماتنا",
        courses: "الدورات",
        trainers: "المدربون",
        achievements: "إنجازاتنا",
        gallery: "المعرض",
        contact: "تواصل معنا",
        register: "التسجيل",
      },

      // =====================================================
      // HOME
      // =====================================================
      home: {
        heroTag: "مركز مداد للتدريب والتطوير",
        heroTitle: "نصنع المعرفة",
        heroTitle2: "ونبني المستقبل",

        heroText:
          "نقدم برامج تعليمية وتدريبية متخصصة تساعد الطلاب والشباب على تطوير مهاراتهم، اكتشاف قدراتهم، والاستعداد لمستقبل أكثر نجاحًا.",

        heroButton: "استكشف دوراتنا",
        heroButton2: "تعرّف علينا",

        floating1: "تعليم",
        floating2: "تطوير",
        floating3: "مستقبل",

        statsTitle: "أرقام نفتخر بها",

        students: "طالب ومستفيد",
        programs: "برنامج ودورة",
        trainers: "مدرب ومتخصص",
        experience: "سنوات من الخبرة",

        servicesTag: "ماذا نقدم؟",
        servicesTitle:
          "من المعرفة إلى المهارة… ومن المهارة إلى النجاح.",

        service1Title: "التعليم والدعم الأكاديمي",
        service1Text:
          "نساعد الطلاب على تعزيز مستواهم الدراسي وفهم المواد بشكل أفضل من خلال برامج التقوية والدعم الأكاديمي.",

        service2Title: "تنمية القدرات",
        service2Text:
          "نطوّر التركيز والذاكرة وسرعة التفكير والقدرات الذهنية من خلال برامج مثل الحساب الذهني والشطرنج.",

        service3Title: "التكنولوجيا والمهارات الرقمية",
        service3Text:
          "من البرمجة والكمبيوتر إلى التصميم والتصوير، نساعدك على اكتساب مهارات تواكب العالم الرقمي.",

        service4Title: "التدريب والتطوير المهني",
        service4Text:
          "دورات عملية تساعدك على اكتساب مهارات مهنية جديدة في مجالات متنوعة مثل التمريض والصيدلة واللغات.",

        learnMore: "اكتشف المزيد",

        whyTag: "لماذا مركز مداد؟",
        whyTitle:
          "لأن التعلم الحقيقي يبدأ عندما تتحول المعرفة إلى مهارة.",

        whyText:
          "في مركز مداد نؤمن أن كل شخص يمتلك قدرات يمكن تطويرها. لذلك نوفر بيئة تعليمية وتدريبية تجمع بين المعرفة والتطبيق والمتابعة.",

        point1: "برامج تعليمية وتدريبية متنوعة",
        point2: "مدربون ومتخصصون بخبرة عملية",
        point3: "بيئة تعليمية تفاعلية ومحفزة",
        point4: "مهارات عملية قابلة للتطبيق",

        whyButton: "اعرف المزيد عن المركز",

        ctaTitle: "جاهز تبدأ خطوتك الجديدة؟",
        ctaText:
          "انضم إلى مركز مداد وابدأ رحلة التعلم والتطوير واكتساب مهارات جديدة.",
        ctaButton: "سجّل الآن",
      },

      // =====================================================
      // ABOUT
      // =====================================================
      about: {
        tag: "عن مركز مداد",

        title: "نؤمن بالتعلم",
        titleHighlight: "الذي يصنع الفرق",

        description:
          "مركز مداد هو مساحة تعليمية وتدريبية تهدف إلى تطوير المهارات، دعم المتعلمين، وتوفير فرص حقيقية للنمو الأكاديمي والمهني.",

        introTag: "من نحن؟",
        introTitle:
          "مكان يجمع بين التعليم، التدريب، والتطوير.",

        introText:
          "نسعى في مركز مداد إلى تقديم تجربة تعليمية مختلفة تركز على احتياجات المتعلم وتساعده على اكتساب المعرفة والمهارات التي يحتاجها في دراسته وحياته المهنية.",

        introButton: "اكتشف برامجنا",

        valuesTag: "قيمنا",
        valuesTitle: "المبادئ التي نعمل من خلالها",

        visionTitle: "رؤيتنا",
        visionText:
          "أن نكون مركزًا رائدًا في التعليم والتدريب وتطوير المهارات، وأن نساهم في بناء جيل أكثر معرفة وقدرة على صناعة مستقبله.",

        missionTitle: "رسالتنا",
        missionText:
          "توفير برامج تعليمية وتدريبية ذات جودة تساعد الأفراد على تطوير قدراتهم وتحويل المعرفة إلى مهارات عملية.",

        goalsTitle: "أهدافنا",
        goalsText:
          "دعم الطلاب، تطوير المهارات، توفير التدريب العملي، ومساعدة المتعلمين على تحقيق أهدافهم الأكاديمية والمهنية.",

        whyTag: "لماذا مداد؟",
        whyTitle: "نتعلم لنصبح أفضل.",

        whyText:
          "نركز على تقديم تجربة تجمع بين التعليم النظري والتطبيق العملي، مع الاهتمام بالفروق الفردية واحتياجات كل متعلم.",

        point1: "برامج متنوعة تناسب احتياجات مختلفة",
        point2: "مدربون ومتخصصون",
        point3: "تدريب عملي وتفاعلي",
        point4: "متابعة ودعم مستمر",

        ctaTag: "ابدأ رحلتك",
        ctaTitle: "خطوتك القادمة تبدأ من هنا.",

        ctaText:
          "اكتشف برامج مركز مداد واختر المجال الذي يساعدك على تطوير نفسك.",

        ctaButton: "تواصل معنا",
      },

      // =====================================================
      // COURSES
      // =====================================================
      courses: {
        tag: "الدورات والبرامج",
        title: "تعلم مهارات جديدة",

        intro:
          "اكتشف مجموعة من البرامج والدورات التعليمية والتدريبية المصممة لتطوير مهاراتك وتحقيق أهدافك.",

        programsTag: "برامجنا",
        programsTitle:
          "دورات مصممة لتناسب احتياجاتك",

        programsText:
          "نوفر برامج متنوعة في التعليم، التكنولوجيا، اللغات، المهارات المهنية والتنمية الشخصية.",

        course1Title: "الحساب الذهني",
        course1Text:
          "برنامج يساعد على تطوير سرعة الحساب والتركيز والذاكرة والقدرات الذهنية.",
        course1Category: "تنمية القدرات",

        course2Title: "البرمجة",
        course2Text:
          "تعلم أساسيات البرمجة واكتسب مهارات تقنية تساعدك على فهم عالم التكنولوجيا.",
        course2Category: "تكنولوجيا",

        course3Title: "الكمبيوتر",
        course3Text:
          "تعلم استخدام الحاسوب والبرامج الأساسية بطريقة عملية وسهلة.",
        course3Category: "تكنولوجيا",

        course4Title: "اللغات الإنجليزية والفرنسية",
        course4Text:
          "طوّر مهاراتك في اللغة الإنجليزية والفرنسية من خلال التدريب والممارسة.",
        course4Category: "لغات",

        course5Title: "أسس التمريض",
        course5Text:
          "تعرف على المبادئ الأساسية في مجال التمريض واكتسب معرفة عملية.",
        course5Category: "تدريب مهني",

        course6Title: "مساعد صيدلي",
        course6Text:
          "برنامج تدريبي للتعرف على أساسيات العمل في مجال الصيدلة ومهام مساعد الصيدلي.",
        course6Category: "تدريب مهني",

        register: "سجّل الآن",

        ctaTag: "خطوتك تبدأ الآن",
        ctaTitle:
          "اختر الدورة التي تناسب أهدافك.",

        ctaText:
          "سجّل في أحد برامج مركز مداد وابدأ رحلة جديدة نحو تطوير مهاراتك.",

        ctaButton: "التسجيل",
      },

      // =====================================================
      // SERVICES
      // =====================================================
      services: {
        tag: "خدماتنا",

        heroTitle: "خدمات تساعدك",
        heroHighlight: "على التطور والنجاح",

        heroText:
          "نقدم مجموعة متنوعة من الخدمات والبرامج التعليمية والتدريبية التي تلبي احتياجات الطلاب والشباب والمهتمين بتطوير مهاراتهم.",

        listTag: "ماذا نقدم؟",
        listTitle:
          "مجموعة متنوعة من البرامج والخدمات",

        listText:
          "اختر المجال الذي يناسبك وابدأ بتطوير مهاراتك مع مركز مداد.",

        service1Title: "الحساب الذهني",
        service1Text:
          "برنامج تفاعلي لتنمية سرعة الحساب، التركيز، الذاكرة والقدرات الذهنية.",

        service2Title: "تدريب على الخط",
        service2Text:
          "برنامج يساعد الأطفال والطلاب على تحسين الخط والكتابة بطريقة صحيحة وجميلة.",

        service3Title:
          "المفكرة من الصف الأول حتى الصف الثاني",
        service3Text:
          "برنامج دعم ومتابعة يساعد الطلاب في المراحل الدراسية الأولى على تنظيم تعلمهم.",

        service4Title: "AutoCAD",
        service4Text:
          "تعلم أساسيات استخدام AutoCAD وتطوير مهارات الرسم والتصميم الهندسي.",

        service5Title: "رحلات ترفيهية",
        service5Text:
          "رحلات وأنشطة ترفيهية تجمع بين المتعة والتفاعل واكتساب تجارب جديدة.",

        service6Title: "الشطرنج",
        service6Text:
          "تعلم الشطرنج وتطوير التركيز، التخطيط، التفكير المنطقي واتخاذ القرار.",

        service7Title: "مساعد صيدلي",
        service7Text:
          "برنامج تدريبي للتعرف على أساسيات العمل ومهام مساعد الصيدلي.",

        service8Title:
          "دورات تقوية في المواد العلمية",
        service8Text:
          "دعم أكاديمي وتقوية في المواد العلمية لمساعدة الطلاب على تحسين مستواهم الدراسي.",

        service9Title: "الكمبيوتر",
        service9Text:
          "تطوير مهارات استخدام الحاسوب والبرامج الأساسية بطريقة عملية.",

        service10Title: "الرسم",
        service10Text:
          "تنمية الإبداع والمهارات الفنية من خلال تعلم أساسيات الرسم والتعبير الفني.",

        service11Title:
          "اللغات الإنجليزية والفرنسية",
        service11Text:
          "برامج لتطوير مهارات اللغة الإنجليزية والفرنسية من خلال التعلم والممارسة.",

        service12Title: "أسس التمريض",
        service12Text:
          "التعرف على المبادئ والأساسيات الأولية في مجال التمريض.",

        service13Title: "التصوير",
        service13Text:
          "تعلم أساسيات التصوير وتطوير مهاراتك في التقاط الصور بطريقة احترافية.",

        service14Title:
          "دعم صعوبات التعلم",
        service14Text:
          "برامج دعم تساعد المتعلمين الذين يواجهون صعوبات في التعلم وفق احتياجاتهم.",

        service15Title:
          "دعم طلاب التعليم المهني",
        service15Text:
          "دعم ومتابعة لطلاب التعليم المهني لمساعدتهم على تطوير مستواهم وتحقيق أهدافهم.",

        register: "سجّل الآن",

        ctaTag: "ابدأ الآن",
        ctaTitle:
          "مهارة جديدة قد تكون بداية فرصة جديدة.",

        ctaText:
          "اختر البرنامج المناسب لك وابدأ رحلة التعلم والتطوير مع مركز مداد.",

        ctaButton: "سجّل الآن",
      },

      // =====================================================
      // TRAINERS
      // =====================================================
      trainersPage: {
        tag: "فريقنا",

        title: "تعلم مع",
        titleHighlight: "خبراء ومتخصصين",

        description:
          "يضم مركز مداد فريقًا من المدربين والمتخصصين الذين يساهمون في تقديم تجربة تعليمية وتدريبية مميزة.",

        teamTag: "فريق المدربين",
        teamTitle:
          "خبرات تساعدك على التطور",

        teamText:
          "نحرص على اختيار مدربين يمتلكون المعرفة والخبرة والقدرة على تقديم المعلومة بطريقة واضحة وتفاعلية.",

        experience: "سنوات خبرة",

        loading: "جاري تحميل المدربين...",

        emptyTitle: "لا يوجد مدربون حاليًا",
        emptyText:
          "سيتم عرض المدربين هنا عند إضافتهم.",

        ctaTag: "تعلم معنا",
        ctaTitle: "جاهز تطور مهاراتك؟",

        ctaText:
          "اكتشف برامجنا وتعلم على يد مدربين ومتخصصين.",

        ctaButton: "اكتشف الدورات",
      },

      // =====================================================
      // ACHIEVEMENTS
      // PUBLIC + ADMIN
      // =====================================================
      achievements: {
        // -------------------------
        // PUBLIC PAGE
        // -------------------------
        tag: "إنجازاتنا",

        title: "نفخر بما حققناه",
        titleHighlight: "مع طلابنا",

        description:
          "كل إنجاز هو نتيجة للتعلم والاجتهاد والدعم. نفتخر بالنتائج والإنجازات التي حققها طلابنا ومتدربونا.",

        // -------------------------
        // ADMIN HEADER
        // -------------------------
        dashboardBadge: "لوحة إدارة الإنجازات",

        dashboardTitle: "إدارة الإنجازات",

        dashboardSubtitle:
          "أضف وعدّل واحذف إنجازات المركز التي تظهر على الموقع.",

        add: "إضافة إنجاز",

        // -------------------------
        // FORM
        // -------------------------
        formSubtitle:
          "أدخل تفاصيل الإنجاز والمعلومات التي تريد عرضها على الموقع.",

        edit: "تعديل الإنجاز",

        titleAr: "عنوان الإنجاز بالعربية",

        titleEn: "عنوان الإنجاز بالإنجليزية",

        titleArPlaceholder:
          "أدخل عنوان الإنجاز بالعربية",

        titleEnPlaceholder:
          "Enter achievement title in English",

        descriptionAr:
          "وصف الإنجاز بالعربية",

        descriptionEn:
          "وصف الإنجاز بالإنجليزية",

        descriptionArPlaceholder:
          "اكتب وصف الإنجاز بالعربية...",

        descriptionEnPlaceholder:
          "Write achievement description in English...",

        year: "السنة",

        image: "صورة الإنجاز",

        chooseImage: "اختر صورة للإنجاز",

        changeImage: "تغيير الصورة",

        invalidImage:
          "يرجى اختيار ملف صورة صالح.",

        // -------------------------
        // FORM ACTIONS
        // -------------------------
        save: "حفظ الإنجاز",

        saveChanges: "حفظ التعديلات",

        cancel: "إلغاء",

        saving: "جاري الحفظ...",

        // -------------------------
        // LIST
        // -------------------------
        allAchievements: "جميع الإنجازات",

        achievementCount: "إنجاز",

        loading: "جاري تحميل الإنجازات...",

        noAchievements:
          "لا توجد إنجازات حاليًا",

        noAchievementsText:
          "ستظهر الإنجازات هنا عند إضافتها من لوحة الإدارة.",

        // -------------------------
        // DELETE
        // -------------------------
        delete: "حذف",

        confirmDelete:
          "هل أنت متأكد من رغبتك في حذف هذا الإنجاز؟",

        // -------------------------
        // SUCCESS
        // -------------------------
        successAdd:
          "تمت إضافة الإنجاز بنجاح.",

        successEdit:
          "تم تعديل الإنجاز بنجاح.",

        successUpdate:
          "تم تعديل الإنجاز بنجاح.",

        successDelete:
          "تم حذف الإنجاز بنجاح.",

        // -------------------------
        // ERRORS
        // -------------------------
        saveError:
          "حدث خطأ أثناء حفظ الإنجاز. يرجى المحاولة مرة أخرى.",

        deleteError:
          "حدث خطأ أثناء حذف الإنجاز. يرجى المحاولة مرة أخرى.",

        error:
          "حدث خطأ ما. يرجى المحاولة مرة أخرى.",

        // -------------------------
        // OLD / ALTERNATIVE KEYS
        // Keep them for compatibility
        // -------------------------
        addAchievement: "إضافة إنجاز",

        titleLabel: "عنوان الإنجاز",

        descriptionLabel: "وصف الإنجاز",

        imageLabel: "صورة الإنجاز",

        dateLabel: "التاريخ",

        emptyTitle: "لا توجد إنجازات حاليًا",

        emptyText:
          "ستظهر الإنجازات هنا عند إضافتها.",

        deleteConfirm:
          "هل أنت متأكد من رغبتك في حذف هذا الإنجاز؟",
      },

      // =====================================================
      // CONTACT
      // =====================================================
      contact: {
        tag: "تواصل معنا",

        title: "نحن هنا",
        titleHighlight: "لأجلك",

        description:
          "لديك سؤال أو تريد معرفة المزيد عن برامجنا؟ تواصل معنا وسنكون سعداء بمساعدتك.",

        infoTag: "تواصل معنا",
        infoTitle: "معلومات التواصل",

        infoText:
          "يسعدنا تواصلك معنا والإجابة عن جميع استفساراتك.",

        phoneTitle: "الهاتف",
        phoneText: "اتصل بنا مباشرة",
        phoneValue: "+961 XX XXX XXX",

        whatsappTitle: "واتساب",
        whatsappText:
          "تواصل معنا عبر واتساب",
        whatsappValue: "+961 XX XXX XXX",

        emailTitle: "البريد الإلكتروني",
        emailText:
          "راسلنا عبر البريد الإلكتروني",
        emailValue:
          "info@madadcenter.com",

        locationTitle: "الموقع",
        locationText:
          "زورونا في مركز مداد",
        locationValue:
          "طرابلس، لبنان",

        formTag: "ابقَ على تواصل",
        formTitle: "أرسل لنا رسالة",

        workingHoursTitle: "ساعات العمل",
        workingHours:
          "نحن متواجدون لخدمتكم",
        workingHoursTime:
          "يوميًا حسب مواعيد المركز",

        nameLabel: "الاسم الكامل",
        namePlaceholder:
          "أدخل اسمك الكامل",

        phoneLabel: "رقم الهاتف",
        phonePlaceholder:
          "أدخل رقم هاتفك",

        emailLabel: "البريد الإلكتروني",
        emailPlaceholder:
          "أدخل بريدك الإلكتروني",

        subjectLabel: "الموضوع",
        subjectPlaceholder:
          "موضوع الرسالة",

        messageLabel: "الرسالة",
        messagePlaceholder:
          "اكتب رسالتك هنا...",

        submit: "إرسال الرسالة",
        sending: "جاري الإرسال...",

        whatsappButton:
          "التواصل عبر واتساب",

        whatsappMessage:
          "مرحبًا، أود الاستفسار عن برامج ودورات مركز مداد.",

        requiredName:
          "يرجى إدخال الاسم الكامل.",

        requiredPhone:
          "يرجى إدخال رقم الهاتف.",

        requiredMessage:
          "يرجى كتابة الرسالة.",

        successTitle:
          "تم إرسال رسالتك بنجاح!",

        successText:
          "سنتواصل معك قريبًا.",

        success:
          "تم إرسال رسالتك بنجاح! سنتواصل معك قريبًا.",

        error:
          "حدث خطأ أثناء إرسال الرسالة. يرجى المحاولة مرة أخرى.",
      },

      // =====================================================
      // REGISTRATION
      // =====================================================
      registration: {
        tag: "التسجيل",

        heroTitle: "ابدأ رحلتك",
        heroTitleHighlight: "مع مركز مداد",

        heroText:
          "خطوتك الأولى نحو التعلم والتطوير تبدأ من هنا. املأ طلب التسجيل وسنتواصل معك قريبًا.",

        welcome: "مرحبًا بك في مداد",

        firstStep: "خطوتك الأولى",
        startsHere: "تبدأ من هنا",

        infoText:
          "نحن نؤمن أن كل رحلة نجاح تبدأ بخطوة. سجّل معنا وابدأ بتطوير مهاراتك واكتشاف قدراتك.",

        programs: "برامج ودورات متنوعة",

        trainers:
          "مدربون ومتخصصون",

        environment:
          "بيئة تعليمية محفزة",

        contactTitle:
          "للاستفسار والتواصل",

        traineeInfo:
          "معلومات المتدرب",

        basicInfo:
          "أدخل معلوماتك الأساسية للتسجيل.",

        course:
          "الدورة / البرنامج",

        coursePlaceholder:
          "اكتب اسم الدورة أو البرنامج",

        fullName:
          "الاسم الكامل",

        fullNamePlaceholder:
          "أدخل الاسم الكامل",

        age:
          "العمر",

        agePlaceholder:
          "أدخل العمر",

        parentName:
          "اسم ولي الأمر",

        parentPlaceholder:
          "أدخل اسم ولي الأمر",

        gender:
          "الجنس",

        choose:
          "اختر",

        male:
          "ذكر",

        female:
          "أنثى",

        contactInfo:
          "معلومات التواصل",

        contactDescription:
          "أدخل معلومات التواصل التي يمكننا استخدامها للتواصل معك.",

        phone:
          "رقم الهاتف",

        phonePlaceholder:
          "03 000 000",

        whatsapp:
          "رقم واتساب",

        email:
          "البريد الإلكتروني",

        emailPlaceholder:
          "example@email.com",

        area:
          "المنطقة",

        areaPlaceholder:
          "أدخل منطقتك",

        additionalInfo:
          "معلومات إضافية",

        additionalDescription:
          "ساعدنا في معرفة المزيد عنك واهتماماتك.",

        education:
          "المرحلة التعليمية / الاختصاص",

        educationPlaceholder:
          "مثال: مدرسة، جامعة، تعليم مهني...",

        previous:
          "هل سبق وسجلت في مركز مداد؟",

        yes:
          "نعم",

        no:
          "لا",

        howFound:
          "كيف تعرفت على مركز مداد؟",

        friend:
          "عن طريق صديق / شخص أعرفه",

        center:
          "عن طريق المركز",

        other:
          "أخرى",

        notes:
          "ملاحظات أو استفسارات",

        notesPlaceholder:
          "اكتب أي ملاحظات أو معلومات إضافية تود مشاركتها معنا...",

        submit:
          "إرسال طلب التسجيل",

        privacy:
          "نحافظ على خصوصية معلوماتك ولن نستخدمها إلا للتواصل معك بخصوص التسجيل.",

        whatsappTitle:
          "طلب تسجيل جديد - مركز مداد",

        whatsappCourse:
          "الدورة / البرنامج",

        whatsappName:
          "الاسم الكامل",

        whatsappParent:
          "اسم ولي الأمر",

        whatsappAge:
          "العمر",

        whatsappGender:
          "الجنس",

        whatsappArea:
          "المنطقة",

        whatsappPhone:
          "رقم الهاتف",

        whatsappNumber:
          "رقم واتساب",

        whatsappEmail:
          "البريد الإلكتروني",

        whatsappEducation:
          "المرحلة التعليمية / الاختصاص",

        whatsappPrevious:
          "التسجيل السابق",

        whatsappFound:
          "كيف تعرفت علينا",

        whatsappNotes:
          "الملاحظات",

        notSpecified:
          "غير محدد",

        notAvailable:
          "غير متوفر",

        none:
          "لا يوجد",

        thanks:
          "شكرًا لاهتمامك بمركز مداد! سنتواصل معك قريبًا لتأكيد التسجيل.",
      },

      // =====================================================
      // FOOTER
      // =====================================================
      footer: {
        description:
          "مركز مداد للتعليم والتدريب والتطوير. نساعدك على اكتساب المعرفة والمهارات التي تصنع مستقبلك.",

        quickLinks:
          "روابط سريعة",

        servicesTitle:
          "خدماتنا",

        contactTitle:
          "تواصل معنا",

        courses:
          "الدورات",

        registration:
          "التسجيل",

        trainers:
          "المدربون",

        achievements:
          "إنجازاتنا",

        contact:
          "تواصل معنا",

        phone:
          "الهاتف",

        whatsapp:
          "واتساب",

        email:
          "البريد الإلكتروني",

        location:
          "الموقع",

        ctaTag:
          "ابدأ رحلتك",

        ctaTitle:
          "استثمر في مهاراتك اليوم.",

        ctaButton:
          "سجّل الآن",

        rights:
          "جميع الحقوق محفوظة © 2026 مركز مداد",

        madeWith:
          "صُنع بـ ❤️ من أجل التعلم والتطوير",
      },
    },
  },

  // =========================================================
  // ENGLISH
  // =========================================================
  en: {
    translation: {
      // =====================================================
      // NAVIGATION
      // =====================================================
      nav: {
        home: "Home",
        about: "About Us",
        services: "Services",
        courses: "Courses",
        trainers: "Trainers",
        achievements: "Achievements",
        gallery: "Gallery",
        contact: "Contact",
        register: "Register",
      },

      // =====================================================
      // HOME
      // =====================================================
      home: {
        heroTag:
          "Madad Center for Training & Development",

        heroTitle:
          "Creating Knowledge",

        heroTitle2:
          "Building the Future",

        heroText:
          "We provide specialized educational and training programs that help students and young people develop their skills, discover their potential, and prepare for a more successful future.",

        heroButton:
          "Explore Our Courses",

        heroButton2:
          "About Us",

        floating1:
          "Education",

        floating2:
          "Development",

        floating3:
          "Future",

        statsTitle:
          "Numbers We Are Proud Of",

        students:
          "Students & Beneficiaries",

        programs:
          "Programs & Courses",

        trainers:
          "Trainers & Specialists",

        experience:
          "Years of Experience",

        servicesTag:
          "WHAT WE OFFER",

        servicesTitle:
          "From Knowledge to Skills… From Skills to Success.",

        service1Title:
          "Education & Academic Support",

        service1Text:
          "We help students strengthen their academic performance and better understand their subjects through tutoring and academic support programs.",

        service2Title:
          "Skills & Ability Development",

        service2Text:
          "We develop focus, memory, mental speed, and cognitive abilities through programs such as mental math and chess.",

        service3Title:
          "Technology & Digital Skills",

        service3Text:
          "From programming and computer skills to design and photography, we help you build skills for today's digital world.",

        service4Title:
          "Professional Training & Development",

        service4Text:
          "Practical courses that help you gain new professional skills in fields such as nursing, pharmacy, and languages.",

        learnMore:
          "Discover More",

        whyTag:
          "WHY MADAD CENTER?",

        whyTitle:
          "Because real learning begins when knowledge becomes a skill.",

        whyText:
          "At Madad Center, we believe everyone has potential that can be developed. That is why we provide an educational and training environment that combines knowledge, practice, and continuous support.",

        point1:
          "Diverse educational and training programs",

        point2:
          "Experienced trainers and specialists",

        point3:
          "Interactive and motivating learning environment",

        point4:
          "Practical and applicable skills",

        whyButton:
          "Learn More About Us",

        ctaTitle:
          "Ready to Take Your Next Step?",

        ctaText:
          "Join Madad Center and start your journey of learning, development, and acquiring new skills.",

        ctaButton:
          "Register Now",
      },

      // =====================================================
      // ABOUT
      // =====================================================
      about: {
        tag:
          "ABOUT MADAD CENTER",

        title:
          "We Believe in Learning",

        titleHighlight:
          "That Makes a Difference",

        description:
          "Madad Center is an educational and training space focused on developing skills, supporting learners, and providing real opportunities for academic and professional growth.",

        introTag:
          "WHO WE ARE",

        introTitle:
          "A place that brings education, training, and development together.",

        introText:
          "At Madad Center, we aim to provide a different learning experience that focuses on learners' needs and helps them gain the knowledge and skills they need in their studies and professional lives.",

        introButton:
          "Explore Our Programs",

        valuesTag:
          "OUR VALUES",

        valuesTitle:
          "The principles behind our work",

        visionTitle:
          "Our Vision",

        visionText:
          "To become a leading center in education, training, and skills development, contributing to building a more knowledgeable generation capable of shaping its future.",

        missionTitle:
          "Our Mission",

        missionText:
          "To provide quality educational and training programs that help individuals develop their abilities and turn knowledge into practical skills.",

        goalsTitle:
          "Our Goals",

        goalsText:
          "Supporting students, developing skills, providing practical training, and helping learners achieve their academic and professional goals.",

        whyTag:
          "WHY MADAD?",

        whyTitle:
          "We learn to become better.",

        whyText:
          "We focus on providing an experience that combines theoretical learning with practical application while considering individual differences and learners' needs.",

        point1:
          "Diverse programs for different needs",

        point2:
          "Experienced trainers and specialists",

        point3:
          "Practical and interactive training",

        point4:
          "Continuous support and follow-up",

        ctaTag:
          "START YOUR JOURNEY",

        ctaTitle:
          "Your next step starts here.",

        ctaText:
          "Explore Madad Center's programs and choose the field that helps you develop yourself.",

        ctaButton:
          "Contact Us",
      },

      // =====================================================
      // COURSES
      // =====================================================
      courses: {
        tag:
          "COURSES & PROGRAMS",

        title:
          "Learn New Skills",

        intro:
          "Explore a variety of educational and training programs designed to develop your skills and help you achieve your goals.",

        programsTag:
          "OUR PROGRAMS",

        programsTitle:
          "Courses Designed Around Your Needs",

        programsText:
          "We offer diverse programs in education, technology, languages, professional skills, and personal development.",

        course1Title:
          "Mental Math",

        course1Text:
          "A program designed to improve calculation speed, focus, memory, and mental abilities.",

        course1Category:
          "Skills Development",

        course2Title:
          "Programming",

        course2Text:
          "Learn programming fundamentals and develop technical skills to understand the world of technology.",

        course2Category:
          "Technology",

        course3Title:
          "Computer Skills",

        course3Text:
          "Learn how to use computers and essential software through practical and easy-to-follow training.",

        course3Category:
          "Technology",

        course4Title:
          "English & French Languages",

        course4Text:
          "Develop your English and French language skills through learning and practice.",

        course4Category:
          "Languages",

        course5Title:
          "Nursing Fundamentals",

        course5Text:
          "Learn the basic principles of nursing and gain practical knowledge.",

        course5Category:
          "Professional Training",

        course6Title:
          "Pharmacy Assistant",

        course6Text:
          "A training program introducing the fundamentals of pharmacy work and pharmacy assistant responsibilities.",

        course6Category:
          "Professional Training",

        register:
          "Register Now",

        ctaTag:
          "YOUR JOURNEY STARTS NOW",

        ctaTitle:
          "Choose the course that matches your goals.",

        ctaText:
          "Register in one of Madad Center's programs and start a new journey toward developing your skills.",

        ctaButton:
          "Register",
      },

      // =====================================================
      // SERVICES
      // =====================================================
      services: {
        tag:
          "OUR SERVICES",

        heroTitle:
          "Services That Help You",

        heroHighlight:
          "Grow & Succeed",

        heroText:
          "We provide a variety of educational and training services designed to meet the needs of students, young people, and anyone interested in developing their skills.",

        listTag:
          "WHAT WE OFFER",

        listTitle:
          "A Variety of Programs & Services",

        listText:
          "Choose the field that suits you and start developing your skills with Madad Center.",

        service1Title:
          "Mental Math",

        service1Text:
          "An interactive program designed to develop calculation speed, focus, memory, and mental abilities.",

        service2Title:
          "Handwriting Training",

        service2Text:
          "A program designed to help children and students improve their handwriting and writing skills.",

        service3Title:
          "Educational Planner – Grade 1 to Grade 2",

        service3Text:
          "A support and follow-up program that helps students in the early grades organize and improve their learning.",

        service4Title:
          "AutoCAD",

        service4Text:
          "Learn the fundamentals of AutoCAD and develop technical drawing and engineering design skills.",

        service5Title:
          "Recreational Trips",

        service5Text:
          "Recreational trips and activities that combine fun, interaction, and new experiences.",

        service6Title:
          "Chess",

        service6Text:
          "Learn chess while developing focus, planning, logical thinking, and decision-making skills.",

        service7Title:
          "Pharmacy Assistant",

        service7Text:
          "A training program introducing the fundamentals and responsibilities of a pharmacy assistant.",

        service8Title:
          "Science Tutoring",

        service8Text:
          "Academic support and tutoring in science subjects to help students improve their academic performance.",

        service9Title:
          "Computer Skills",

        service9Text:
          "Develop your computer skills and learn essential software through practical training.",

        service10Title:
          "Drawing",

        service10Text:
          "Develop creativity and artistic skills by learning the fundamentals of drawing and artistic expression.",

        service11Title:
          "English & French Languages",

        service11Text:
          "Programs designed to develop English and French language skills through learning and practice.",

        service12Title:
          "Nursing Fundamentals",

        service12Text:
          "Learn the basic principles and fundamentals of nursing.",

        service13Title:
          "Photography",

        service13Text:
          "Learn photography fundamentals and develop your ability to capture images professionally.",

        service14Title:
          "Learning Difficulties Support",

        service14Text:
          "Support programs designed for learners who experience learning difficulties according to their individual needs.",

        service15Title:
          "Vocational Student Support",

        service15Text:
          "Support and follow-up for vocational students to help them improve their performance and achieve their goals.",

        register:
          "Register Now",

        ctaTag:
          "START NOW",

        ctaTitle:
          "A new skill can be the beginning of a new opportunity.",

        ctaText:
          "Choose the program that suits you and start your learning and development journey with Madad Center.",

        ctaButton:
          "Register Now",
      },

      // =====================================================
      // TRAINERS
      // =====================================================
      trainersPage: {
        tag:
          "OUR TEAM",

        title:
          "Learn With",

        titleHighlight:
          "Experts & Specialists",

        description:
          "Madad Center brings together a team of trainers and specialists who contribute to providing an outstanding educational and training experience.",

        teamTag:
          "OUR TRAINERS",

        teamTitle:
          "Experience That Helps You Grow",

        teamText:
          "We carefully select trainers who have the knowledge, experience, and ability to deliver information in a clear and interactive way.",

        experience:
          "Years of Experience",

        loading:
          "Loading trainers...",

        emptyTitle:
          "No trainers available",

        emptyText:
          "Trainers will appear here once they are added.",

        ctaTag:
          "LEARN WITH US",

        ctaTitle:
          "Ready to develop your skills?",

        ctaText:
          "Explore our programs and learn with experienced trainers and specialists.",

        ctaButton:
          "Explore Courses",
      },

      // =====================================================
      // ACHIEVEMENTS
      // PUBLIC + ADMIN
      // =====================================================
      achievements: {
        // -------------------------
        // PUBLIC PAGE
        // -------------------------
        tag:
          "OUR ACHIEVEMENTS",

        title:
          "Proud of What We Have Achieved",

        titleHighlight:
          "With Our Students",

        description:
          "Every achievement is the result of learning, dedication, and support. We are proud of the results achieved by our students and trainees.",

        // -------------------------
        // ADMIN HEADER
        // -------------------------
        dashboardBadge:
          "Achievements Management",

        dashboardTitle:
          "Manage Achievements",

        dashboardSubtitle:
          "Add, edit, and delete the achievements displayed on the website.",

        add:
          "Add Achievement",

        // -------------------------
        // FORM
        // -------------------------
        formSubtitle:
          "Enter the achievement details and information you want to display on the website.",

        edit:
          "Edit Achievement",

        titleAr:
          "Achievement Title in Arabic",

        titleEn:
          "Achievement Title in English",

        titleArPlaceholder:
          "Enter achievement title in Arabic",

        titleEnPlaceholder:
          "Enter achievement title in English",

        descriptionAr:
          "Achievement Description in Arabic",

        descriptionEn:
          "Achievement Description in English",

        descriptionArPlaceholder:
          "Write achievement description in Arabic...",

        descriptionEnPlaceholder:
          "Write achievement description in English...",

        year:
          "Year",

        image:
          "Achievement Image",

        chooseImage:
          "Choose Achievement Image",

        changeImage:
          "Change Image",

        invalidImage:
          "Please choose a valid image file.",

        // -------------------------
        // FORM ACTIONS
        // -------------------------
        save:
          "Save Achievement",

        saveChanges:
          "Save Changes",

        cancel:
          "Cancel",

        saving:
          "Saving...",

        // -------------------------
        // LIST
        // -------------------------
        allAchievements:
          "All Achievements",

        achievementCount:
          "achievements",

        loading:
          "Loading achievements...",

        noAchievements:
          "No achievements yet",

        noAchievementsText:
          "Achievements will appear here once they are added from the admin dashboard.",

        // -------------------------
        // DELETE
        // -------------------------
        delete:
          "Delete",

        confirmDelete:
          "Are you sure you want to delete this achievement?",

        // -------------------------
        // SUCCESS
        // -------------------------
        successAdd:
          "Achievement added successfully.",

        successEdit:
          "Achievement updated successfully.",

        successUpdate:
          "Achievement updated successfully.",

        successDelete:
          "Achievement deleted successfully.",

        // -------------------------
        // ERRORS
        // -------------------------
        saveError:
          "An error occurred while saving the achievement. Please try again.",

        deleteError:
          "An error occurred while deleting the achievement. Please try again.",

        error:
          "Something went wrong. Please try again.",

        // -------------------------
        // OLD / ALTERNATIVE KEYS
        // -------------------------
        addAchievement:
          "Add Achievement",

        titleLabel:
          "Achievement Title",

        descriptionLabel:
          "Achievement Description",

        imageLabel:
          "Achievement Image",

        dateLabel:
          "Date",

        emptyTitle:
          "No achievements yet",

        emptyText:
          "Achievements will appear here once they are added.",

        deleteConfirm:
          "Are you sure you want to delete this achievement?",
      },

      // =====================================================
      // CONTACT
      // =====================================================
      contact: {
        tag:
          "CONTACT US",

        title:
          "We Are Here",

        titleHighlight:
          "For You",

        description:
          "Have a question or want to learn more about our programs? Contact us and we will be happy to help.",

        infoTag:
          "GET IN TOUCH",

        infoTitle:
          "Contact Information",

        infoText:
          "We are happy to hear from you and answer all your questions.",

        phoneTitle:
          "Phone",

        phoneText:
          "Call us directly",

        phoneValue:
          "+961 XX XXX XXX",

        whatsappTitle:
          "WhatsApp",

        whatsappText:
          "Contact us through WhatsApp",

        whatsappValue:
          "+961 XX XXX XXX",

        emailTitle:
          "Email",

        emailText:
          "Email us directly",

        emailValue:
          "info@madadcenter.com",

        locationTitle:
          "Location",

        locationText:
          "Visit us at Madad Center",

        locationValue:
          "Tripoli, Lebanon",

        formTag:
          "SEND US A MESSAGE",

        formTitle:
          "Send Us a Message",

        workingHoursTitle:
          "Working Hours",

        workingHours:
          "We are available to assist you",

        workingHoursTime:
          "Daily according to center hours",

        nameLabel:
          "Full Name",

        namePlaceholder:
          "Enter your full name",

        phoneLabel:
          "Phone Number",

        phonePlaceholder:
          "Enter your phone number",

        emailLabel:
          "Email Address",

        emailPlaceholder:
          "Enter your email address",

        subjectLabel:
          "Subject",

        subjectPlaceholder:
          "Message subject",

        messageLabel:
          "Message",

        messagePlaceholder:
          "Write your message here...",

        submit:
          "Send Message",

        sending:
          "Sending...",

        whatsappButton:
          "Contact Us on WhatsApp",

        whatsappMessage:
          "Hello, I would like to ask about Madad Center's programs and courses.",

        requiredName:
          "Please enter your full name.",

        requiredPhone:
          "Please enter your phone number.",

        requiredMessage:
          "Please enter your message.",

        successTitle:
          "Your message has been sent successfully!",

        successText:
          "We will contact you soon.",

        success:
          "Your message has been sent successfully! We will contact you soon.",

        error:
          "An error occurred while sending the message. Please try again.",
      },

      // =====================================================
      // REGISTRATION
      // =====================================================
      registration: {
        tag:
          "REGISTRATION",

        heroTitle:
          "Start Your Journey",

        heroTitleHighlight:
          "With Madad Center",

        heroText:
          "Your first step toward learning and development starts here. Fill out the registration form and we will contact you soon.",

        welcome:
          "WELCOME TO MADAD",

        firstStep:
          "Your First Step",

        startsHere:
          "Starts Here",

        infoText:
          "We believe every success journey starts with a single step. Register with us and start developing your skills and discovering your potential.",

        programs:
          "Diverse Programs & Courses",

        trainers:
          "Experienced Trainers & Specialists",

        environment:
          "Motivating Learning Environment",

        contactTitle:
          "For Questions & Contact",

        traineeInfo:
          "Trainee Information",

        basicInfo:
          "Enter your basic information to register.",

        course:
          "Course / Program",

        coursePlaceholder:
          "Enter the course or program name",

        fullName:
          "Full Name",

        fullNamePlaceholder:
          "Enter your full name",

        age:
          "Age",

        agePlaceholder:
          "Enter your age",

        parentName:
          "Parent / Guardian Name",

        parentPlaceholder:
          "Enter parent or guardian name",

        gender:
          "Gender",

        choose:
          "Choose",

        male:
          "Male",

        female:
          "Female",

        contactInfo:
          "Contact Information",

        contactDescription:
          "Enter the contact information we can use to reach you.",

        phone:
          "Phone Number",

        phonePlaceholder:
          "03 000 000",

        whatsapp:
          "WhatsApp Number",

        email:
          "Email Address",

        emailPlaceholder:
          "example@email.com",

        area:
          "Area",

        areaPlaceholder:
          "Enter your area",

        additionalInfo:
          "Additional Information",

        additionalDescription:
          "Help us learn more about you and your interests.",

        education:
          "Education Level / Major",

        educationPlaceholder:
          "Example: School, University, Vocational...",

        previous:
          "Have you registered at Madad Center before?",

        yes:
          "Yes",

        no:
          "No",

        howFound:
          "How did you hear about Madad Center?",

        friend:
          "Through a friend / Someone I know",

        center:
          "Through the Center",

        other:
          "Other",

        notes:
          "Notes or Questions",

        notesPlaceholder:
          "Write any notes or additional information you would like to share with us...",

        submit:
          "Submit Registration",

        privacy:
          "Your information is kept private and will only be used to contact you regarding your registration.",

        whatsappTitle:
          "New Registration Request - Madad Center",

        whatsappCourse:
          "Course / Program",

        whatsappName:
          "Full Name",

        whatsappParent:
          "Parent / Guardian",

        whatsappAge:
          "Age",

        whatsappGender:
          "Gender",

        whatsappArea:
          "Area",

        whatsappPhone:
          "Phone Number",

        whatsappNumber:
          "WhatsApp Number",

        whatsappEmail:
          "Email Address",

        whatsappEducation:
          "Education Level / Major",

        whatsappPrevious:
          "Previous Registration",

        whatsappFound:
          "How They Heard About Us",

        whatsappNotes:
          "Notes",

        notSpecified:
          "Not specified",

        notAvailable:
          "Not available",

        none:
          "None",

        thanks:
          "Thank you for your interest in Madad Center! We will contact you soon to confirm your registration.",
      },

      // =====================================================
      // FOOTER
      // =====================================================
      footer: {
        description:
          "Madad Center for Education, Training, and Development. We help you gain the knowledge and skills that shape your future.",

        quickLinks:
          "Quick Links",

        servicesTitle:
          "Our Services",

        contactTitle:
          "Contact Us",

        courses:
          "Courses",

        registration:
          "Registration",

        trainers:
          "Trainers",

        achievements:
          "Achievements",

        contact:
          "Contact Us",

        phone:
          "Phone",

        whatsapp:
          "WhatsApp",

        email:
          "Email",

        location:
          "Location",

        ctaTag:
          "START YOUR JOURNEY",

        ctaTitle:
          "Invest in your skills today.",

        ctaButton:
          "Register Now",

        rights:
          "All Rights Reserved © 2026 Madad Center",

        madeWith:
          "Made with ❤️ for learning and development",
      },
    },
  },
};

// =========================================================
// INITIALIZE I18N
// =========================================================

i18n
  .use(initReactI18next)
  .init({
    resources,

    lng: "ar",

    fallbackLng: "ar",

    supportedLngs: ["ar", "en"],

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;